export const room = [
  {
    path: '/room',
    component: () => import(/* webpackChunkName: "room" */ '@/views/room/Room'),
    children: [
      {
        path: 'create',
        components: {
          body: () => import(/* webpackChunkName: "room" */ '@/views/room/components/RoomEditBody'),
          bar: () => import(/* webpackChunkName: "room" */ '@/views/room/components/RoomEditBar'),
        },
      },
      {
        path: ':id/edit',
        components: {
          body: () => import(/* webpackChunkName: "room" */ '@/views/room/components/RoomEditBody'),
          bar: () => import(/* webpackChunkName: "room" */ '@/views/room/components/RoomEditBar'),
        },
      },
    ]
  },
]
